import { useMemo } from "react";
import { Col, Row } from "reactstrap";
import Widget from "src/modules/data-protection/pages/admin/dashboard/components/Widget";
import completedIcon from "src/modules/data-protection/assets/icons/tasks_completed.svg";
import inProgressIcon from "src/modules/data-protection/assets/icons/tasks_in_progress.svg";
import openTasksIcon from "src/modules/data-protection/assets/icons/tasks_open_tasks.svg";
import overdueIcon from "src/modules/data-protection/assets/icons/tasks_overdue.svg";

import { getDashboardMetric } from "src/modules/data-protection/helpers/Controls";

const toWidgetConfig = ({ title, metric, icon }) => {
  const { amount, percent } = getDashboardMetric(metric);

  return {
    title,
    amount,
    icon,
    chart: { show: true, percent },
  };
};

const TasksActionsWidgets = ({ dashboardData }) => {
  const taskWidgets = useMemo(() => {
    const tasks = dashboardData?.tasks_and_actions || {};

    return [
      toWidgetConfig({
        title: "Open Tasks",
        metric: tasks.open_tasks,
        icon: openTasksIcon,
      }),
      toWidgetConfig({
        title: "Overdue",
        metric: tasks.overdue,
        icon: overdueIcon,
      }),
      toWidgetConfig({
        title: "In Progress",
        metric: tasks.in_progress,
        icon: inProgressIcon,
      }),
      toWidgetConfig({
        title: "Completed",
        metric: tasks.completed,
        icon: completedIcon,
      }),
    ];
  }, [dashboardData]);

  return (
    <Row className="mb-4">
      {taskWidgets.map((widget) => (
        <Col lg="3" md="6" sm="12" key={widget.title} className="mb-3">
          <Widget {...widget} />
        </Col>
      ))}
    </Row>
  );
};

export default TasksActionsWidgets;
